module.exports = __webpack_public_path__ + "img/logo-grupo.5481f1a5.png";